var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"set_sizes_holder"},[_c('div',{staticClass:"set_sizes"},[_c('div',{ref:"field",staticClass:"current_size",style:({
                width: ((_vm.width * _vm.MAX_WIDTH / 300) + "px"),
                height: ((_vm.height * _vm.MAX_HEIGHT / 300) + "px")
            })})]),_c('div',{ref:"heightSlider",attrs:{"id":"height-slider"}}),_c('div',{ref:"widthSlider",attrs:{"id":"width-slider"}})])}
var staticRenderFns = []

export { render, staticRenderFns }